<input
  type="radio"
  [checked]="checked()"
  [disabled]="deshabilitado()"
  [id]="idUnico"
  [attr.name]="name()"
  (change)="onChange()"
/>
@if (label(); as texto) {
  <label [for]="idUnico">{{ texto }}</label>
}
